export const faceMaskMode = ["smart", "stable"] as const;
